<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="算法">
              <a-input placeholder="请输入算法" v-model="queryParam.taskType"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="摄像头名称">
              <a-input placeholder="请输入摄像头名称" v-model="queryParam.cameraName"></a-input>
            </a-form-item>
          </a-col>
            <a-col :lg="7" :md="8" :sm="24" :xl="6">
              <a-form-item label="是否启用">
                <j-multi-select-tag @change="searchQuery" dictCode="yn" type="checkbox" v-model="queryParam.enabled" />
              </a-form-item>
            </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('视频识别算法配置')" icon="download" type="primary">导出</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="alertLevel" slot-scope="text, record">
          <a-tag :color="$filterDictTextByCache('alert_level_color', record.alertLevel)">{{record.alertLevel_dictText}}</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <edgeboard-tasktype-config-modal @ok="modalFormOk" ref="modalForm"></edgeboard-tasktype-config-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EdgeboardTasktypeConfigModal from './modules/EdgeboardTasktypeConfigModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'EdgeboardTasktypeConfigList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      EdgeboardTasktypeConfigModal
    },
    data () {
      return {
        isorter: {
            column: 'taskType',
            order: 'asc'
        },
        description: '视频识别算法可信度配置管理页面',
        // 表头
        columns: [
          {
            title: '算法',
            align: "center",
            dataIndex: 'taskType',
            sorter: true
          },
          {
            title: '摄像头名称',
            align: "center",
            dataIndex: 'cameraName',
            sorter: true
          },
          {
            title: '可信度',
            align: "center",
            dataIndex: 'score',
            sorter: true
          },
                  {
          title: '告警级别',
          align: "center",
          dataIndex: 'alertLevel',
          scopedSlots: { customRender: 'alertLevel' },
          sorter: true,
        },
          {
            title: '锁闭时间(分)',
            align: "center",
            dataIndex: 'lockMin',
            sorter: true
          },
          {
            title: '是否启用',
            align: "center",
            dataIndex: 'enabled_dictText',
            sorter: true
          },
          {
            title: '消息推送',
            align: "center",
            dataIndex: 'alertPushId_dictText',
            sorter: true
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/alert/edgeboardTasktypeConfig/list",
          delete: "/alert/edgeboardTasktypeConfig/delete",
          deleteBatch: "/alert/edgeboardTasktypeConfig/deleteBatch",
          exportXlsUrl: "/alert/edgeboardTasktypeConfig/exportXls",
          importExcelUrl: "alert/edgeboardTasktypeConfig/importExcel",
        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'taskType', text: '算法', dictCode: '' })
        fieldList.push({ type: 'string', value: 'cameraName', text: '摄像头名称', dictCode: '' })
        fieldList.push({ type: 'double', value: 'score', text: '可信度', dictCode: '' })
        fieldList.push({ type: 'int', value: 'lockMin', text: '锁闭时间(分)', dictCode: '' })
        fieldList.push({ type: 'int', value: 'enabled', text: '是否启用', dictCode: 'yn' })
        fieldList.push({ type: 'list_multi', value: 'alertPushId', text: '消息推送', dictTable: '`iwt-wf`.iot_alert_push', dictText: 'name', dictCode: 'id' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>